<template>
  <div class="jobs" v-if="$root.dataReady">
    <div class="container">
      <div class="jobs__content">
        <div
          class="jobs__image"
          :style="{
            'background-image': 'url( ' + post.featured_image + ' )',
          }"
        >
          <span class="jobs__title" v-html="post.acf_preview.job_title"></span>
        </div>
        <p class="jobs__position" v-html="post.acf_preview.position"></p>
        <p
          class="jobs__city"
          v-if="post.acf_preview.city"
          v-html="post.acf_preview.city"
        ></p>
        <p class="jobs__description" v-html="post.acf_preview.content"></p>
        <div class="jobs__grey-box" v-html="post.acf_preview.grey_box"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "post-preview-jobs",
  data() {
    return {
      post: null,
    };
  },
  created: function () {
    this.$root.dataReady = false;
    this.$root.headeriswhite = false;
  },
  mounted: function () {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      var self = this;
      if (!this.$route.params.preview_key || !this.$route.params.id) {
        self.$router.push({ name: "page-not-found" });
      } else {
        $.get(
          self.$root.apiUrl +
            "wp-json/wp/v2/jobs/" +
            this.$route.params.id +
            "/preview?preview_key=" +
            this.$route.params.preview_key,
          function (response) {
            if (!response) {
              self.$router.push({ name: "page-not-found" });
            } else {
              self.post = response;
              self.setTitle(response.title.rendered);
              self.$root.dataReady = true;
            }
          }
        )
          .done(function () {})
          .fail(function () {
            self.$router.push({ name: "page-not-found" });
          });
      }
    },
    removeAccents: function (title) {
      return title.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    setTitle: function(title) {
        title = title.normalize('NFD').replace("&#038;", "&");
        document.title = title + " - Weber Shandwick";
    }
  },
};
</script>



// WEBPACK FOOTER //
// JobsPreview.vue?7ae86a16